import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingService } from '@shared/services/loading/loading.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-loading',
    standalone: false,
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.css']
})
export class LoadingComponent {
    @Input() message: string = 'Loading...';
    @Input() diameter: number = 50;
    @Input() overlay: boolean = true; // If true, shows as overlay; if false, shows inline
    @Input() key: string = 'global'; // Key to track specific loading state

    loading$: Observable<boolean>;

    constructor(private loadingService: LoadingService) {
        this.loading$ = this.loadingService.loading$;
    }

    get isLoading(): boolean {
        if (this.key === 'global') {
            return this.loadingService.isLoading();
        }
        return this.loadingService.isLoadingKey(this.key);
    }
}
